<template>
  <div class="my-5" v-html="props.calculatedData.html"></div>
  <div class="row justify-content-end myTopMargin">
    <div class="col-auto">
      <ButtonTwoLines
        main-text="Zrušit"
        secondary-text="bez uložení"
        variant="danger"
        size="lg"
        @click="cancelButton"
      />
<!--      <ButtonTwoLines-->
<!--        main-text="Uložit PDF"-->
<!--        secondary-text="Verze S - minimalistická"-->
<!--        variant="success"-->
<!--        size="lg"-->
<!--        icon="bi bi-file-earmark-pdf"-->
<!--        @click="saveVersion(1)"-->
<!--      />-->
      <ButtonTwoLines
        main-text="Uložit PDF"
        secondary-text="Verze M - standardní"
        variant="success"
        size="lg"
        icon="bi bi-file-earmark-pdf"
        @click="saveVersion(2)"
      />
      <ButtonTwoLines
        main-text="Uložit PDF"
        secondary-text="Verze L - podrobná"
        variant="success"
        size="lg"
        icon="bi bi-file-earmark-pdf"
        @click="saveVersion(3)"
      />
    </div>
  </div>
</template>

<script setup>
import {defineProps, defineOptions, defineEmits, reactive} from 'vue'
import myApi from "@/api/api";
import router from "@/router";
import ButtonTwoLines from "@/components/base/ButtonTwoLines.vue";

defineOptions({
  name: "CalculationCalculateTable"
})

const props = defineProps(['calculation', 'calculatedData'])
const emit = defineEmits(['cancel', 'updatePdfFile'])
const localCalculatedData = reactive({...props.calculatedData})

const cancelButton = () => {
  emit('cancel')
}

const offer_version_mapper = {
  1: 'S',
  2: 'M',
  3: 'L',
}

const saveVersion = async (offer_version) => {
  // const pdf_file = await myApi.createPdfOffer({'offer_version': offer_version, 'data': props.calculatedData.version.data})
  // localCalculatedData.version.pdf_file = pdf_file.pdf
  localCalculatedData.version.pdf_offer_type = offer_version_mapper[offer_version]
  console.log(localCalculatedData)
  await myApi.createCalculationVersion(localCalculatedData.version)
  await myApi.setCalculationStatus(props.calculation.uid, 'calculated')
  await router.push({
    name: 'home'
  })
}
</script>

<style scoped>
</style>